export { default as TabPanels } from './TabPanels'
